import planRestrictions from '../planRestrictions.js'


function getInitialState(){
	const product = JSON.parse(localStorage.getItem('service.product'))
	if(product){
		return planRestrictions[product]
	}else return planRestrictions.free


}



export default function (state = getInitialState(), action) {
	switch (action.type) {

	case 'FETCH_SERVICE_SUCCESS':
		if(action.response.product==='plus'){
			return planRestrictions.plus
		}else return planRestrictions.free
		

	
	case 'UPDATE_SERVICE_SUCCESS':
		if(action.response.product==='plus'){
			return planRestrictions.plus
		}else return planRestrictions.free


	case 'LOGOUT':
		return getInitialState()
	
	default:
		return state
	}
}



// WEBPACK FOOTER //
// ./src/reducers/planRestrictions.js